import React, { useCallback, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import styles from '../../../styles/layout.module.css';
import { Breadcrumb, Button, Row, Select, Space, Spin, Typography } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ClusterOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDeviceByName } from '../../../features/devicesTypes/devicesTypes.hooks';
import { deleteDevice, fetchDevice } from '../../../features/devicesTypes/devicesTypes.state';
import { DeviceType } from '../../../features/devicesTypes/devicesTypes.types';
import { fetchPhyDevice, fetchPhyDevices, updatePhyDevice } from '../../../features/phy_devices/state';
import { useAppSelector } from '../../../hooks/hooks';
import { selectDeviceById } from '../../../features/phy_devices/selector';
import { PhyDevice, PhyDeviceUpdate } from '../../../features/phy_devices/types';
import { FormattedMessage, useIntl } from 'react-intl';
import EditableField from '../../fields/EditableField';
import ConfirmButton from '../../atoms/ConfirmButton';
import { DraftCompany } from '../../../features/companies/companies.types';
import { updateCompany } from '../../../features/companies/companies.state';
import InputEditableField from '../../fields/InputEditableField';

const DevicePage: React.FC = () => {
  const { deviceId } = useParams() as { deviceId: string };
  const dispatch = useDispatch();
  const device = useAppSelector(selectDeviceById(deviceId)) as PhyDevice;

  // const handleDeleteButtonClick = useCallback(() => {
  //   dispatch(deleteDevice({ deviceTypeName }));
  // }, [deviceTypeName, dispatch]);

  // const handleCompanyUpdate = useCallback(
  //   (data: Partial<CompanyRoom>) => {
  //     dispatch(updateDevice({ deviceTypeName, data }));
  //   },
  //   [deviceTypeName, dispatch]
  // );
  const intl = useIntl();
  const handleUpdate = useCallback(
    (data: PhyDeviceUpdate) => {
      dispatch(updatePhyDevice({ deviceId, data }));
    },
    [deviceId, dispatch]
  );
  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/devices'>
                <Space>
                  <ClusterOutlined />
                  Устройства
                </Space>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{device.label || device.id}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            {device.label || device.id}
          </Typography.Title>
          <Space size='small' />
        </div>
        <div className={styles.sidebar}>
          <Space direction={'vertical'}>
            {device.disabled ? (
              <Button type='primary' onClick={() => handleUpdate({ disabled: !device.disabled })}>
                Разблокировать
              </Button>
            ) : (
              <ConfirmButton type='primary' onClick={() => handleUpdate({ disabled: !device.disabled })} danger>
                Заблокировать
              </ConfirmButton>
            )}
          </Space>
          <div className={styles.propertiesGrid}>
            <Typography.Text className={styles.title}>Метка</Typography.Text>
            <InputEditableField value={device.label} onBlur={e => handleUpdate({ label: e })} />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

const DevicePageBlock: React.FC = () => {
  const { deviceId } = useParams() as { deviceId: string };
  const dispatch = useDispatch();
  const device = useAppSelector(selectDeviceById(deviceId));

  useEffect(() => {
    dispatch(fetchPhyDevice(deviceId));
  }, [deviceId, dispatch]);

  if (!device) {
    return (
      <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
        <Spin size={'large'} />
      </Row>
    );
  }

  return <DevicePage />;
};

export default DevicePageBlock;
